module.exports = __webpack_public_path__ + "img/password.02b4030c.png";